export class BrandStatistics {
    brandName: string;
    mediaFile: string;
    requestCount: number;
    logoUrl: string
    associatedToBrandUtc: string;
    createdUtc: string;
    adTrailerUrl: string;
    adTrailerStatus: number;
    logoHeight: number;
    logoWidth: number;
    title: string;
    description: string;
}

export class AdTrailerStatusEnum {
    static readonly None: number = 0;
    static readonly Pending: number = 1;
    static readonly Created: number = 2;
}

export class AdTrailer {
    id: number;
    mediaFile: string;
    adTrailerUrl: string;
    adTrailerStatus: number;
}


// WEBPACK FOOTER //
// ./src/app/brand-statistics/brand-statistics.model.ts